import React, { useEffect, useState } from "react";
import SwiperCore, { Autoplay, FreeMode, Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import ImageCarouselCard from "../ImageCarouselCard/ImageCarouselCard";
import styles from "./ImageCarousel.module.scss";
import useWindowResize from "../../hooks/useWindowResize";

SwiperCore.use([Autoplay, Pagination, Navigation, FreeMode]);

const ImageCarousel = ({ bigSlides = false, items, title, smallImg=false }) => {
  const [list, setList] = useState([]);
  const isBelowMedium = useWindowResize(768);

  useEffect(() => {
    if (items) {
      setList(
        items.map((d, i) => (
          <SwiperSlide key={i}>
            <ImageCarouselCard key={i} image={d.image} name={d.name} bigSlides={bigSlides} />
          </SwiperSlide>
        ))
      );
    }
  }, [items]);

  return (
    <div className={styles.ImageCarousel}>
      {title && <div className={styles.cardIntroText} style={{ display: bigSlides && title ? "none" : "block" }}>{title.toUpperCase()}</div>}
      <div>
        <div className={bigSlides ? 'imageCarousel' : 'imageCarouselSmall'}>
          <Swiper
            slidesPerView={"auto"}
            spaceBetween={3}
            loop
            loopedSlides={30}
            loopAdditionalSlides={30}
            freeMode
            speed={2000}
            autoplay={{
              disableOnInteraction: false,
            }}
          >
            {list}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default ImageCarousel;
